import * as constants from './constants'

export function carParkRates(state = [], action) {
    if (action.type === constants.SET_RATES) return action.rates
    return state
}
